import { render, staticRenderFns } from "./FieldCustomObject.vue?vue&type=template&id=33ffd972&scoped=true&"
import script from "./FieldCustomObject.vue?vue&type=script&lang=js&"
export * from "./FieldCustomObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ffd972",
  null
  
)

export default component.exports